import { object, string } from "yup";

export const RolesSchema = object().shape({
  roleName: string().required("Vendos emrin e rolit!")
});
